import React from "react";
import {
	defineMessages,
	FormatDateOptions,
	FormattedMessage,
	useIntl
} from "react-intl";

import { Event } from "lib/build/events";
import { Antecedent } from "lib/build/recordings";

import { Field } from "src/common/components/Field";
import { MultiSelect } from "src/common/components/MultiSelect";
import { useFormatFsn } from "src/common/hooks/useFormatFsn";
import { genericMessages } from "src/messages/generic";

const messages = defineMessages({
	antecedents: {
		id: "form.antecedents",
		defaultMessage: "Előzmények"
	}
});

const formatDateOptions: FormatDateOptions = {
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
	second: "numeric"
};

interface AntecedentsProps {
	disabled?: boolean;
	events: Event[];
	antecedents: Antecedent[];
	onChangeAntecedents(antecedents: Antecedent[]): unknown;
}

export const Antecedents: React.FunctionComponent<AntecedentsProps> = ({
	disabled,
	events,
	antecedents,
	onChangeAntecedents
}) => {
	const { formatDate, formatMessage } = useIntl();
	const formatFsn = useFormatFsn();
	const options = React.useMemo(
		() =>
			events.map(event => {
				const { sid, timestamp, interpretation, deleted } = event;
				let label = `${formatDate(
					timestamp,
					formatDateOptions
				)} - ${formatFsn(interpretation)}`;
				if (deleted) {
					label += ` - ${formatMessage(genericMessages.deleted)}`;
				}
				return { value: { sid, timestamp }, label };
			}),
		[events, formatDate, formatMessage, formatFsn]
	);
	return (
		<Field label={<FormattedMessage {...messages.antecedents} />}>
			<MultiSelect<Antecedent>
				disabled={disabled}
				options={options}
				value={antecedents}
				onChangeValue={onChangeAntecedents}
			/>
		</Field>
	);
};
